<template>
  <div class="address">
    <Header msg='我的地址'/>
    <div style="height:0.44rem;"></div>
    <div class="address-box">
        <!-- 收货人 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>收货人</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right">
                    <input v-model="pageData.name" placeholder="请填写收货人" />
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 联系电话 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>联系电话</span>
                <div class="flex flex-j-c-e flex-a-i-center method-right">
                    <input type='number' v-model="pageData.mobile" placeholder="请填写电话" oninput="if(value.length > 11)value = value.slice(0, 11)"/>
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 所在地区 -->
        <div class="per-line">
            <div class=" flex flex-j-c-sb">
                <span>所在地区</span>
                <div class="flex flex-j-c-e method-right" @click="showPopup('city')">
                  <span class="ellipsis">{{cityShow||'请选择地区'}}</span>
                  <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- 详细地址 -->
        <div class="per-line addressDetails">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span>详细地址</span>
                <div></div>
            </div>
        </div>
        <div>
          <textarea v-model="pageData.detail" placeholder="请填写详细地址" class="textinput"/>
        </div>
    </div>

    <mt-popup
        v-model="popupVisible"
        popup-transition="popup-fade"
        position="bottom"
        class="mint-popup">
        <mt-picker :slots="slots" :valueKey="Indexes" @change="onValuesChange" :itemHeight="50" showToolbar ref="picker">
            <mt-header :title.sync="popupName">
                <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
                <mt-button slot="right" @click="handleConfirm">确定</mt-button>
            </mt-header>
        </mt-picker>
    </mt-popup>

    <mt-button @click.native="isReady" size="large" :class="btnJudge ? 'bgColor':''">确认提交</mt-button>
    
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { Toast, MessageBox } from 'mint-ui';
import { cityLink, getAddressDetail, SaveAddress } from '@/api';

export default {
  name: 'Address',
  components: {
    Header
  },
  data() {
    return {
      pageData: {}, // 页面数据
      btnJudge: false, // 提交是否不可用
      popupVisible: false, // picker 显示/隐藏
      popupType: '', // 联动类型
      popupName: '', // 联动名称
      Indexes: 'name', // 联动索引
      city: [{},{},{}], // 城市
      cityShow: '', // 城市展示数据
      cityData: '', // 获取的城市数据
      changeCityIndex: [0, 0, 0], // 城市更改id
      changeCityId: [0, 0, 0], // 城市更改id
      slots: [{flex: 1, values: [], className: 'slot1', textAlign: 'center'}], // 联动数据
      func: {} // 定位城市
    }
  },
  created(){
    this.getDetail();
  },
  mounted () {
    // MessageBox.alert('功能完善中...').then(action => {
    //   this.$router.go(-1);
    // });
  },
  methods: {
    // 修改提交
    isReady() {
      let params = {}, judge = true;
      params.address_id = this.pageData.address_id ? this.pageData.address_id : 0;
      if(!this.pageData.name) {
        Toast({message: '请输入收货人', className: 'iconfont icon-close'});
        judge = false;
        return false;
      } else { params.name = this.pageData.name; };
      if(!this.pageData.mobile) {
        Toast({message: '请输入联系电话', className: 'iconfont icon-close'});
        judge = false;
        return false;
      } else if(!this._tools.checkPhone(this.pageData.mobile)){
        Toast({message: '请输入正确的联系电话', className: 'iconfont icon-close'});
        judge = false;
        return false;
      } else { params.mobile = this.pageData.mobile; };
      if(!this.pageData.detail) {
        Toast({message: '请输入详细地址', className: 'iconfont icon-close'});
        judge = false;
        return false;
      } else { params.detail = this.pageData.detail; };
      if(judge) {
        params.province_id = this.city[0].id;
        params.city_id = this.city[1].id;
        params.district_id = this.city[2].id;
        SaveAddress(params).then(res => {
          Toast({message: res.msg});
          if (res.code === 0) {
            setTimeout(res => {
              this.$router.go(-1);
            }, 2000)
          }
        })
      }
    },
    // 匹配默认城市
    initChooseCity(Arr) {
      Arr.map((item, index) => {
        if (item.id === this.pageData.district[item.level].id){
          this.func[item.level] = {item, index}
          if (item.list) {
            this.initChooseCity(item.list)
          }
        };
      })
    },
    // 城市联动接口
    getCity() {
      cityLink().then(res => {
        // this.cityData = res.data;
        let defaultCity = [{}, {}, {}];
        if (res.data.length !== 0) {
          if (this.pageData.address_id) {
            this.initChooseCity(res.data);
            this.city = [this.func.province.item, this.func.city.item, this.func.district.item];
            this.changeCityIndex = [this.func.province.index, this.func.city.index, this.func.district.index];
            this.cityShow = `${this.city[0].name}-${this.city[1].name}-${this.city[2].name}`
          } else {
            res.data.map((item, index) => {
              if (item.id === 1941) {
                let city = [];
                item.list.map(citem => {
                  if (citem.id === 1942 || citem.id === 1986 || citem.id === 2066) city.push(citem);
                })
                item.list = city;
                this.cityData = [item];
                defaultCity[0] = item;
                this.changeCityIndex[0] = index;
                defaultCity[1] = item.list[0];
                defaultCity[2] = item.list[0].list[0];
              }
            })
            this.city = defaultCity;
            this.cityShow = `${this.city[0].name}-${this.city[1].name}-${this.city[2].name}`
          }
        }
      })
    },
    // 选择选项
    showPopup(str) {
      let judge = true;
      switch (str) {
        case 'city': // 城市
          let province = this.cityData;
          let city = this.cityData[0].list;
          let district = this.cityData[0].list[0].list;
          if (this.popupType === 'city') {
            this.popupVisible = true;
            return false;
          }
          this.slots = [{
            flex: 1,
            values: province,
            className: 'slot1',
            textAlign: 'center',
            defaultIndex: this.changeCityIndex[0]
          }, {
            divider: true,
            content: '-',
            className: 'slot2'
          }, {
            flex: 1,
            values: city,
            className: 'slot3',
            textAlign: 'center',
            defaultIndex: this.changeCityIndex[1]
          }, {
            divider: true,
            content: '-',
            className: 'slot4'
          }, {
            flex: 1,
            values: district,
            className: 'slot5',
            textAlign: 'center',
            defaultIndex: this.changeCityIndex[2]
          }]
          this.servicCampus = {};
          this.popupName = '城市';
          break;
        default:
          Toast({message: '请稍后重试', className: 'iconfont icon-close'});
          judge = false
          break;
      }
      if (judge) {
        this.popupVisible = true;
        this.popupType = str;
      }
    },
    // 变更选项
    onValuesChange(picker, values) {
      if (!this.popupType) return false
      if (this.popupType === 'city') {
        let province = values[0];
        let city = values[1];
        let district = values[2];
        if (province.id !== this.changeCityIndex[0].id) {
          this.changeCityId[0] = province.id
          picker.setSlotValues(1, province.list)
          picker.setSlotValues(2, province.list[0].list)
        }
        if (city.id !== this.changeCityIndex[1].id) {
          this.changeCityId[1] = city.id;
          picker.setSlotValues(2, city.list)
        }
        if (district.id !== this.changeCityIndex[2].id) {
          this.changeCityId[2] = district.id
        }
      }
    },
    // 确定选项
    handleConfirm() {
      switch (this.popupType) {
        case 'city':
          this.city = [this.$refs.picker.getValues()[0], this.$refs.picker.getValues()[1], this.$refs.picker.getValues()[2]]
          this.cityShow = `${this.city[0].name}-${this.city[1].name}-${this.city[2].name}`
          break;
        default:
          Toast({message: '请稍后重试', className: 'iconfont icon-close'});
          break;
      }
      this.popupVisible = false
    },
    // 获取页面数据
    getDetail() {
      getAddressDetail().then(res => {
        if (res.code === 0) {
          this.pageData = res.data;
        } else {
          /** ------------------------------------自动填充相关--------------------------------------------- */
          this.pageData.name = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData')).pdName : '';
          this.pageData.mobile = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData')).pdPhone : '';
          /** ------------------------------------自动填充相关--------------------------------------------- */
        }
        this.getCity();
      })
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
.address{
    padding: 0 0 0.2rem;
    min-height: 100vh;
    font-size: 0.16rem;
    input{
      height: 0.48rem;
    }
    .address-box{
        padding: 0 0.16rem;
        background-color: white;
        margin-top: 0.1rem;
        &>:last-child{
            border: none;
        }
    }
    .addressDetails{
      text-align: left;
      border: none;
      span{
        width: 100%;
      }
    }
    .textinput{
      width: 100%;
      min-height: 1.2rem;
      border: 1px solid #eee;
      border-radius: 3px;
      padding: 10px;
      margin-bottom: 0.1rem;
    }
}
.mint-popup /deep/ .picker{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
    border-radius: 8px 8px 0 0;
    .mint-header{
        background: white;
        height: 0.5rem;
        padding: 0 0.16rem;
        font-size: 0.15rem;
        .is-left{
            color: #999999;
        }
        .is-right{
            color: #FABF01;
        }
    }
    .mint-header-title{
        font-size: 0.17rem;
        color: black;
    }
}
/deep/ .picker-item.picker-selected{
  color: #FABF01;
}
.mint-popup{
    width: 100%;
    border-radius: 8px 8px 0 0;
}
</style> 

